import React from 'react';

const Profile: React.FC = () => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="win-card p-6">
        <h1 className="text-3xl font-bold text-win-dark-text">Profile</h1>
        <p className="text-win-dark-text-muted">Manage your account settings and preferences</p>
      </div>
      {/* Profile content will be implemented */}
    </div>
  );
};

export default Profile;